import { css } from "@emotion/css";
import * as React from "react";
import type { IconProps, IconSize } from "./IconTypes";
type IconWrapperProps = IconProps & {
    children: React.ReactNode;
};
export function IconWrapper({ size, color, ariaLabel, children, title }: IconWrapperProps) {
    const titleId = React.useId();
    const iconStyles = getIconStyles(size, color);
    const ariaAttributes = title ? { "aria-labelledby": titleId, role: "img" } : ariaLabel ? { "aria-label": ariaLabel, role: "img" } : { "aria-hidden": true };
    return (<svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" className={iconStyles} {...ariaAttributes}>
            {title && <title id={titleId}>{title}</title>}
            {children}
        </svg>);
}
function getIconStyles(size: IconSize, color?: string): string {
    const colorToken = color ?? "currentcolor";
    // Icons appear slightly smaller than their viewbox size, so when it's based
    // on the font-size we add 2px to the size to make them look correct
    const iconSize = size === "font-size" ? "calc(1em + 2px)" : `${size}px`;
    return css({
        fill: colorToken,
        display: "block",
        height: iconSize,
        width: iconSize,
    });
}
